import React, {useState} from 'react'
import moment from 'moment'

import { setMonthOpen } from '../../../elements/dateSelector/datesSelectorUtil'
import { Modal, Button } from '../../../elements'
import './searchWizardMobile.sass'
import { DayPickerRangeController } from 'react-dates'
import StyleFilterMobile from '../styleFilter/mobile'

const SearchWizardMobile = (props) => {
  const {
    show,
    step,
    onNextStep,
    onPrevStep,
    onClose,
    showClear,
    onClear,
    startDate,
    endDate,
    additionalDateProps,
    selectedStyles,
    onStyleSelect
  } = props
  const [focusedInput, setFocusedInput] = useState('startDate')

  const initialMonth = () => 
    setMonthOpen(
      moment(),
      endDate ? moment(endDate) : null,
      'startDate'
    )

  const onDatesChange = (startDate, endDate) => {
    props.onDatesChange(startDate, endDate)
  }

  const onFocusChange = (focusedInput) => {
    setFocusedInput(!focusedInput ? 'startDate' : focusedInput)
  }

  const getTitle = () => {
    return step === 1 ? 'When will you be riding? (optional)' : 'Please select your preferred style(s)?'
  }

  return (
    <Modal
      show={show}
      closeOnBlur={false}
      closeOnEsc={false}
      onClose={onClose}
      showClose={false}
    >
      <div className='search-wizard-wrapper'>
        <div className="level is-mobile mb-0 py-3">
          <div className="level-left">
            <div className="level-item">
              <Button
                type="button"
                color="white"
                onClick={onPrevStep}
              >
                <span className="icon is-normal">
                  <i className="far fa-angle-left"></i>
                </span>
              </Button>
            </div>
          </div>
          <div className="level-item has-text-weight-semibold pr-5">
            {getTitle()}
          </div>
        </div>
        <div className='search-wizard-content px-2'>
          {
            step === 1 && (
              <DayPickerRangeController
                onDatesChange={({ startDate, endDate }) =>
                  onDatesChange(startDate, endDate)
                }
                onFocusChange={onFocusChange}
                focusedInput={focusedInput}
                startDate={startDate}
                endDate={endDate}
                readOnly={true}
                orientation="verticalScrollable"
                numberOfMonths={6}
                navPrev={false}
                focused={true}
                initialVisibleMonth={initialMonth}
                hideKeyboardShortcutsPanel
                minimumNights={0}
                {...additionalDateProps}
              />
            )
          }
          {
            step === 2 && (
              <StyleFilterMobile
                currentValues={selectedStyles}
                onSelect={onStyleSelect}
              />
            )
          }
        </div>
        <footer className="actions px-2">
          <div className="level is-mobile mb-0 py-3">
            <div className="level-left">
              <div className="level-item">
                <Button
                  type="button"
                  color="light"
                  onClick={onClear}
                  disabled={!showClear}
                >
                  Clear
                </Button>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item">
                <Button
                  type="button"
                  size="normal"
                  color={`${step <= 1 ? 'dark' : 'primary'}`}
                  // color='primary'
                  onClick={onNextStep}
                >
                  {
                    step <= 1 ? 
                      'Next' : 
                      <>
                        <span className="icon is-small">
                          <i className="far fa-search"></i>
                        </span>
                        <span>Search</span>
                      </>
                  }
                </Button>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </Modal>
  )
}

export default SearchWizardMobile